module.exports = __webpack_public_path__ + "static/liness-66e4e5933b4a08459b5faf66cce70a89.png";